module.exports = __webpack_public_path__ + "img/other.dc815aca.svg";